import React, { useMemo } from "react";
import { Card, EmptyState } from "../../ForBrands/ui/BrandUI";
import { SEASON_COLUMNS, columnTitle, seasonLine, seasonTotals } from "./gameStatsModel";

// Each player's season over the shown season's final games: games played,
// per-game averages and shooting from the counted lines (drafts, DNPs and
// the games Cerebro already has are left out, as the scores leave them).
// Read-only.

const TH = "whitespace-nowrap border-b border-bm-border px-3 py-2.5 bm-label-xs uppercase tracking-[0.06em] text-bm-muted";
const TD = "whitespace-nowrap px-3 py-2.5 text-right bm-body-m tabular-nums text-bm-ink";

const SeasonTotals = ({ games = [], roster = [], season = null }) => {
  const rows = useMemo(() => seasonTotals(games, roster), [games, roster]);
  return (
    <Card padding="p-0" className="overflow-hidden">
      <div className="flex flex-wrap items-baseline justify-between gap-2 border-b border-bm-border px-5 py-4">
        <h2 className="bm-h-s text-bm-ink">Season totals</h2>
        <p className="bm-body-s text-bm-muted">Final games only. Lines Cerebro already has are not counted twice.</p>
      </div>
      {rows.length === 0 ? (
        <EmptyState className="m-5">{season ? `No final games in ${season} yet.` : "No final games yet."}</EmptyState>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full" aria-label={season ? `Season totals, ${season}` : "Season totals"}>
            <thead className="bg-bm-subtle">
              <tr>
                <th scope="col" className={`${TH} text-left`}>
                  Player
                </th>
                {SEASON_COLUMNS.map((col) => (
                  <th key={col.key} scope="col" title={columnTitle(col)} className={`${TH} text-right`}>
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((entry) => {
                const line = seasonLine(entry);
                return (
                  <tr key={entry.playerId} className="border-b border-bm-border last:border-0">
                    <th scope="row" className="px-3 py-2.5 text-left font-normal bm-label-l text-bm-ink">
                      {entry.name}
                    </th>
                    {SEASON_COLUMNS.map((col) => (
                      <td key={col.key} className={TD}>
                        {line[col.key]}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};

export default SeasonTotals;
